import React from 'react';
import { useParams } from 'react-router-dom';
import QuestionnaireBuilder from '../components/QuestionnaireBuilder';

function QuestionnaireBuilderPage() {
  const { id } = useParams();
  
  return <QuestionnaireBuilder formId={id} />;
}

export default QuestionnaireBuilderPage;

